module.exports = __webpack_public_path__ + "static/enerjisa-mockup-6e11905675e4cde225ec23e956d3c39d.png";